"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkRecipientApi = checkRecipientApi;
exports.checkSurveyApi = checkSurveyApi;
exports.linkSingleSoftDeleteApi = linkSingleSoftDeleteApi;
exports.linkSingleSoftDeleteBulkApi = linkSingleSoftDeleteBulkApi;
exports.linkSurveyAndRecipientResponseApi = linkSurveyAndRecipientResponseApi;
exports.recipientAnalyticsGetSurveyRecipientResponseApi = recipientAnalyticsGetSurveyRecipientResponseApi;
exports.recipientApproveApi = recipientApproveApi;
exports.recipientApproveBulkApi = recipientApproveBulkApi;
exports.recipientCopyUrlApi = recipientCopyUrlApi;
exports.recipientCreateApi = recipientCreateApi;
exports.recipientDeleteApi = recipientDeleteApi;
exports.recipientDeleteBulkApi = recipientDeleteBulkApi;
exports.recipientDownloadAllApi = recipientDownloadAllApi;
exports.recipientDownloadApi = recipientDownloadApi;
exports.recipientDownloadSurveyResponseApi = recipientDownloadSurveyResponseApi;
exports.recipientErrorSheetDownloadApi = recipientErrorSheetDownloadApi;
exports.recipientImportApi = recipientImportApi;
exports.recipientLinkedFundApi = recipientLinkedFundApi;
exports.recipientListApi = recipientListApi;
exports.recipientLockApi = recipientLockApi;
exports.recipientLockBulkApi = recipientLockBulkApi;
exports.recipientPrefightApi = recipientPrefightApi;
exports.recipientRestoreApi = recipientRestoreApi;
exports.recipientRestoreBulkApi = recipientRestoreBulkApi;
exports.recipientSaveLinkedFundApi = recipientSaveLinkedFundApi;
exports.recipientSoftDeleteApi = recipientSoftDeleteApi;
exports.recipientSoftDeleteBulkApi = recipientSoftDeleteBulkApi;
exports.recipientSoftDeleteListApi = recipientSoftDeleteListApi;
exports.recipientSubmitApi = recipientSubmitApi;
exports.recipientSubmitBulkApi = recipientSubmitBulkApi;
exports.recipientUniqueMailApi = recipientUniqueMailApi;
exports.recipientUniqueReferenceNoApi = recipientUniqueReferenceNoApi;
exports.recipientUnlockApi = recipientUnlockApi;
exports.recipientUnlockBulkApi = recipientUnlockBulkApi;
exports.recipientUnpageStatusListApi = recipientUnpageStatusListApi;
exports.recipientUpdateApi = recipientUpdateApi;
exports.surveyConfigurationFetchResponseApi = surveyConfigurationFetchResponseApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
function recipientListApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.list), payload);
}

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
function recipientCreateApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.create), payload);
}

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
function recipientUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.update), payload);
}

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund.
 */
function recipientLinkedFundApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.linkedFund), payload);
}

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
function recipientSaveLinkedFundApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.saveLinkedFund), payload);
}

/**
 * Lock
 * @param payload
 * @returns api response
 * @description this function used to Lock.
 */
function recipientLockApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.lock), payload);
}

/**
 * Lock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Lock Bulk.
 */
function recipientLockBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.lockBulk), payload);
}

/**
 * Unlock
 * @param payload
 * @returns api response
 * @description this function used to Unlock.
 */
function recipientUnlockApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.unlock), payload);
}

/**
 * Unlock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Unlock Bulk.
 */
function recipientUnlockBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.unlockBulk), payload);
}

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
function recipientSoftDeleteApi(payload) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.softDelete), payload);
}

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
function recipientSoftDeleteBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.softDeleteBulk), payload);
}

/**
 * Submit
 * @param payload
 * @returns api response
 * @description this function used to Submit.
 */
function recipientSubmitApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.submit), payload);
}

/**
 * Submit Bulk
 * @param payload
 * @returns api response
 * @description this function used to Submit Bulk.
 */
function recipientSubmitBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.submitBulk), payload);
}

/**
 * Approve
 * @param payload
 * @returns api response
 * @description this function used to Approve.
 */
function recipientApproveApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.approve), payload);
}

/**
 * Approve Bulk
 * @param payload
 * @returns api response
 * @description this function used to Approve Bulk.
 */
function recipientApproveBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.approveBulk), payload);
}

/**
 * Copy Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function recipientCopyUrlApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.copyUrl), payload);
}

/**
 * Download
 * @param payload
 * @returns api response
 * @description this function used to Download.
 */
function recipientDownloadApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.download), payload);
}

/**
 * Download All
 * @param payload
 * @returns api response
 * @description this function used to Download All.
 */
function recipientDownloadAllApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.downloadAll), payload);
}

/**
 * Download Survey Response
 * @param payload
 * @returns api response
 * @description this function used to Download Survey Response.
 */
function recipientDownloadSurveyResponseApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.downloadSurveyResponse), payload);
}

// deleted data

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
function recipientSoftDeleteListApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.softDeleteList), payload);
}

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
function recipientRestoreApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.restore), payload);
}

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
function recipientRestoreBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.restoreBulk), payload);
}

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to Delete.
 */
function recipientDeleteApi(payload) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.delete), payload);
}

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
function recipientDeleteBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.deleteBulk), payload);
}

// Uploader

/**
 * Prefight
 * @param payload
 * @returns api response
 * @description this function used to Prefight.
 */
function recipientPrefightApi(payload) {
  return api.createWithParamBody("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.prefight), payload.params, payload.data);
}

/**
 * Import
 * @param payload
 * @returns api response
 * @description this function used to Import.
 */
function recipientImportApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.import), payload);
}

/**
 * Error Sheet Download
 * @param payload
 * @returns api response
 * @description this function used to Error Sheet Download.
 */
function recipientErrorSheetDownloadApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.errorSheetDownload), payload);
}

/**
 * Get Survey Recipient Response
 * @param payload
 * @returns api response
 * @description this function used to Get Survey Recipient Response.
 */
function recipientAnalyticsGetSurveyRecipientResponseApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.analyticsGetSurveyRecipientResponse), payload);
}

/**
 * recipient unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
function recipientUniqueReferenceNoApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.uniqueReferenceNo), params);
}

/**
 * recipient unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
function recipientUniqueMailApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.uniqueMail), params);
}

// Link

/**
 * Check Recipient
 * @param payload
 * @returns api response
 * @description this function used to Check Recipient.
 */
function checkRecipientApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.checkRecipient), payload);
}

/**
 * Check Survey
 * @param payload
 * @returns api response
 * @description this function used to Check Survey.
 */
function checkSurveyApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.checkSurvey), payload);
}

/**
 * Link Survey And Recipient Response
 * @param payload
 * @returns api response
 * @description this function used to Link Survey And Recipient Response.
 */
function linkSurveyAndRecipientResponseApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.linkSurveyAndRecipientResponse), payload);
}

/**
 * Link Single Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete.
 */
function linkSingleSoftDeleteApi(payload) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.linkSingleSoftDelete), payload);
}

/**
 * Link Single Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete Bulk.
 */
function linkSingleSoftDeleteBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.linkSingleSoftDeleteBulk), payload);
}

/**
 * Link Single Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete Bulk.
 */
function recipientUnpageStatusListApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.recipientUnpageStatusList), payload);
}

/**
 * survey configuration fetch
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration.
 */
function surveyConfigurationFetchResponseApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.recipient.configurationFetch), payload);
}